import { render, staticRenderFns } from "./change-pwd.vue?vue&type=template&id=08fd96b1&scoped=true&"
import script from "./change-pwd.vue?vue&type=script&lang=ts&"
export * from "./change-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./change-pwd.vue?vue&type=style&index=0&id=08fd96b1&prod&lang=scss&scoped=true&"
import style1 from "./change-pwd.vue?vue&type=style&index=1&id=08fd96b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd96b1",
  null
  
)

export default component.exports